import { Layer } from "@evergis/sgis";
import { useMemo } from "react";
import { useSGisLayers } from "./useSGisLayer";

const isLayerWithName = (layer: Layer): layer is Layer & { name: string } => layer && "name" in layer;

export const useSGisLayer = (layerName?: string): Layer | null => {
  const sgisLayers = useSGisLayers();

  return useMemo(
    () => sgisLayers.find(layer => isLayerWithName(layer) && layer.name === layerName) || null,
    [sgisLayers, layerName],
  );
};
